import {http} from "@/utils/axios";

export function getCourseDetail ({ id=''}) {
  return http({
    url: http.baseUrl('courseDetail/viewCourseDetail'),
    method: 'get',
    params: http.params({
      id
    })
  })
}

/**
 * @msg: 获取视频课程细节（课程名称）
 */
export function getViewCourseDetail ({ id=''}) {
  return http({
    url: http.baseUrl('/courseDetail/viewCourseDetail'),
    method: 'get',
    params: http.params({
      id
    })
  })
}